module.exports = __webpack_public_path__ + "img/banner.241b8160.png";